import {
    REJECT_TIMECARD,REJECT_TIMECARD_LOADING,REJECT_TIMECARD_FAIL,
  } from "./../actions/actionTypes";

  const DEFAULT_STATE = {
    isLoading: false,
    timecard: {},
    error: {}
  };
  
export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case REJECT_TIMECARD_LOADING:
      return { ...state, isLoading: true };
    case REJECT_TIMECARD:
      return {
        ...state,
        isLoading: false,
        timecard: action.timecard
      };
    case REJECT_TIMECARD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    default:
      return state;
  }
};
  